import React from "react";

const Totales = ({ reserva }) => {
  const moneda = reserva.producto.moneda.codigoMoneda !== "PES" ? "U$D" : "$";
  const tipoCliente = sessionStorage.getItem("tipoCliente");
  //FC: descomentar cuando se cobre en pesos
  /*
  const total = parseFloat(
    Math.ceil(reserva.totalReserva * reserva.producto.moneda.cotizacion)
  ).toLocaleString();

  const totalPublico = parseFloat(
    Math.ceil(
      reserva.totalReservaAgenciaWeb * reserva.producto.moneda.cotizacion
    )
  ).toLocaleString();

  const totalCobrado = parseFloat(
    Math.ceil(reserva.totalCobrado * reserva.producto.moneda.cotizacion)
  ).toLocaleString();

  const saldo = parseFloat(
    Math.ceil(reserva.saldo * reserva.producto.moneda.cotizacion)
  ).toLocaleString();
  */
  const total = parseFloat(Math.ceil(reserva.totalReserva)).toLocaleString();

  const totalPublico = parseFloat(
    Math.ceil(reserva.totalReservaAgenciaWeb)
  ).toLocaleString();

  const totalCobrado = parseFloat(
    Math.ceil(reserva.totalCobrado)
  ).toLocaleString();

  const saldo = parseFloat(Math.ceil(reserva.saldo)).toLocaleString();

  return (
    <div className="misReservasTotales col-xl-4 col-lg-4 col-md-3 col-sm-12 col-12">
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        <p>Total </p>
        <span>
          {moneda} {total}
        </span>{" "}
      </div>
      {tipoCliente !== "IND" && (
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
          <p>Total P&uacute;blico </p>
          <span>
            {moneda} {totalPublico}
          </span>
        </div>
      )}
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        <p>Total Cobrado </p>
        <span>
          {moneda} {totalCobrado}
        </span>{" "}
      </div>

      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
        <p>Saldo </p>
        <span>
          {moneda} {saldo}
        </span>
      </div>
    </div>
  );
};

export default Totales;



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/Totales.js